module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-list-viewer"
  }, [_c('section', {
    ref: "viewerPanel",
    staticClass: "panel viewer-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": "/galleries"
    }
  }, [_vm._v("Galleries")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('View artwork created by other students'),
      expression: "'View artwork created by other students'"
    }],
    staticClass: "clippie fa fa-info-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "headerTags",
    staticStyle: {
      "font-size": "15px",
      "color": "#b0b0b0",
      "margin-left": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.headerTags))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "gallery-controls"
  }, [(_vm.canCreateGallery) ? _c('router-link', {
    staticClass: "btn btn-success create-gallery",
    attrs: {
      "to": "new-gallery"
    }
  }, [_vm._v("\n                    Create\n                ")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.forceSearch($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sort-controls"
  }, [_c('label', [_vm._v("Sort by:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParams.order),
      expression: "searchParams.order"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchParams.order = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.orderOptions), function(order) {
    return _c('option', {
      domProps: {
        "value": order.id
      }
    }, [_vm._v("\n                            " + _vm._s(order.name) + "\n                        ")])
  }))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleFilters
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.showFilters ? 'Hide filters' : 'Show filters') + "\n                ")])], 1), _vm._v(" "), _c('gallery-grid', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGalleries),
      expression: "showGalleries"
    }],
    ref: "galleryGrid",
    attrs: {
      "gutter-width": 0,
      "count-per-row": _vm.galleriesPerRow,
      "threshold-sizing": _vm.galleriesThresholdSizing,
      "galleries": _vm.galleries
    },
    on: {
      "click": _vm.onGalleryClick
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoadingError),
      expression: "showLoadingError"
    }],
    staticClass: "error-container"
  }, [_c('p', [_vm._v("Error loading galleries.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoadingMessage),
      expression: "showLoadingMessage"
    }],
    staticClass: "loading-container"
  }, [_c('p', [_vm._v("Loading...")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNoGalleriesMessage),
      expression: "showNoGalleriesMessage"
    }],
    staticClass: "no-galleries-container"
  }, [_c('p', [_vm._v("No galleries yet.")])])], 1)]), _vm._v(" "), (_vm.showFilters) ? _c('section', {
    staticClass: "panel filters-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group categories"
  }, [_c('label', [_vm._v("Categories")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParams.term),
      expression: "searchParams.term"
    }],
    class: _vm.termSelectClasses,
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchParams.term = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Term")]), _vm._v(" "), _vm._l((_vm.termOptions), function(term) {
    return _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v("\n                            " + _vm._s(term.name) + "\n                        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParams.path),
      expression: "searchParams.path"
    }, {
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTermFoundation(_vm.searchParams.term)),
      expression: "!isTermFoundation(searchParams.term)"
    }],
    class: _vm.pathSelectClasses,
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchParams.path = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Path")]), _vm._v(" "), _vm._l((_vm.pathOptions), function(path) {
    return _c('option', {
      domProps: {
        "value": path.id
      }
    }, [_vm._v("\n                            " + _vm._s(path.name) + "\n                        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.searchParams.group),
      expression: "searchParams.group",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.groupSelectClasses,
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.searchParams.group = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Group")]), _vm._v(" "), _vm._l((_vm.groupOptions), function(group) {
    return _c('option', {
      domProps: {
        "value": group.id
      }
    }, [_vm._v("\n                            " + _vm._s(group.label) + "\n                        ")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParams.condensedAssignment),
      expression: "searchParams.condensedAssignment"
    }],
    class: _vm.assignmentSelectClasses,
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchParams.condensedAssignment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Assignment")]), _vm._v(" "), _vm._l((_vm.condensedAssignmentOptions), function(ca) {
    return _c('option', {
      domProps: {
        "value": ca.id
      }
    }, [_vm._v("\n                            " + _vm._s(ca.name) + "\n                            (" + _vm._s(ca.galleryCount) + ")\n                        ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group author-group"
  }, [_c('label', [_vm._v("Author")]), _vm._v(" "), _c('v-select', {
    class: _vm.authorSelectClasses,
    attrs: {
      "options": _vm.authorOptions,
      "placeholder": "Example"
    },
    on: {
      "search": _vm.searchAuthors
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.handleEmptyAuthorSearch($event)
      }
    },
    model: {
      value: (_vm.searchParams.author),
      callback: function($$v) {
        _vm.searchParams.author = $$v
      },
      expression: "searchParams.author"
    }
  }, [_c('template', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("\n                            Search authors...\n                        ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Software Used")]), _vm._v(" "), _c('software-select', {
    attrs: {
      "options": _vm.gallerySoftware
    },
    model: {
      value: (_vm.searchParams.software),
      callback: function($$v) {
        _vm.searchParams.software = $$v
      },
      expression: "searchParams.software"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group tags"
  }, [_c('label', [_vm._v("Tags")]), _vm._v(" "), _c('tag-select', {
    attrs: {
      "search": _vm.searchTags
    },
    model: {
      value: (_vm.searchParams.tags),
      callback: function($$v) {
        _vm.searchParams.tags = $$v
      },
      expression: "searchParams.tags"
    }
  })], 1), _vm._v(" "), (_vm.canViewHighlights) ? _c('div', {
    staticClass: "form-group recruiter-visibility"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParams.highlightsOnly),
      expression: "searchParams.highlightsOnly"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.searchParams.highlightsOnly) ? _vm._i(_vm.searchParams.highlightsOnly, null) > -1 : (_vm.searchParams.highlightsOnly)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.searchParams.highlightsOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.searchParams.highlightsOnly = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.searchParams.highlightsOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.searchParams.highlightsOnly = $$c
        }
      }
    }
  }), _vm._v("\n                        Show highlights only\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n                        Clear\n                    ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Filters")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e45c488!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryListViewer.vue
// module id = 1953
// module chunks = 2